export const styles = {
    wrapper: {
        width: '100%',
        height: '75%'
    }
};
